import {useState, useEffect, useContext} from 'react';
import axios from 'axios';

import {isAuthenticated} from "../auth";
import {CurrentUserContext} from "../contexts/current-user";
import {apiBaseUrl, siteApiBaseUrl} from '../config/public-config';

export default (url, isBase = false) => {
  const [currentUserState, setCurrentUserState] = useContext(CurrentUserContext);

  const currentSubdomain = currentUserState.currentSite ? currentUserState.currentSite.subdomain : '';
  const baseUrl = isBase ? apiBaseUrl() : siteApiBaseUrl(currentSubdomain);
  const baseOption = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${isAuthenticated().token}`
    }
  };
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [response, setResponse] = useState(null);
  const [meta, setMeta] = useState(null);
  const [options, setOptions] = useState({});

  const doFetch = (options = {}) => {
    const requestOptions = {
      ...baseOption,
      ...options
    };

    if (requestOptions.data instanceof FormData) {
      requestOptions.headers = { ...requestOptions.headers };
      delete requestOptions.headers['Content-Type'];
    }

    setOptions(requestOptions);
    setIsLoading(true);
  };

  useEffect(() => {
    let skipGetResponseAfterDestroy = false;
    if (!isLoading) {
      return;
    }
    setIsLoading(true);
    axios(baseUrl + url, options)
      .then((res) => {
        if (!skipGetResponseAfterDestroy) {
          if(res.status == 204) {
            setResponse({data: {status: "ok"}});
          } else {
            setResponse(res.data);
            if(res.data.meta) {
              setMeta(res.data.meta);
            }
          }
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if (!skipGetResponseAfterDestroy) {
          if(err.response){
            setError(err.response.data);
          }
          setIsLoading(false);
        }
      });

    return () => {
      skipGetResponseAfterDestroy = true;
    };
  }, [isLoading]);

  return [{response, isLoading, error, meta}, doFetch];
}
